import React from "react";
import { Link } from "react-router-dom";

const baseStyle = {
  textDecoration: "none",
  color: "inherit",
};

const Anchor = (props) => {
  if (!props.to) {
    return <span style={baseStyle}>{props.children}</span>;
  }

  if (/^https?:\/\//.test(props.to)) {
    return (
      <a href={props.to} style={baseStyle}>
        {props.children}
      </a>
    );
  }

  return (
    <Link to={props.to} style={baseStyle}>
      {props.children}
    </Link>
  );
};

export default Anchor;